import React from 'react';

import type { GroupDto } from '../../api/types';
import { useAppSelector } from '../../store/hooks';
import { GroupCard } from '../groups/GroupCard';

import './SelectionModals.css';

type GroupSelectModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (groupId: string) => void;
};

export function GroupSelectModal({ isOpen, onClose, onSelect }: GroupSelectModalProps) {
  const groups = useAppSelector((s) => s.entities.groups.items);
  const [search, setSearch] = React.useState('');

  const filteredGroups = React.useMemo(() => {
    return groups.filter((g) => {
      if (!search) return true;
      const q = search.toLowerCase();
      return g.name.toLowerCase().includes(q) || g.description.toLowerCase().includes(q);
    });
  }, [groups, search]);

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleSelect = (group: GroupDto, e: React.MouseEvent) => {
    // Ignore clicks on interactive elements (buttons, links, toggle areas)
    const target = e.target as HTMLElement;
    const isInteractive =
      target.closest('button') ||
      target.closest('a') ||
      target.closest('.members-header') ||
      target.closest('.members-toggle-btn');

    if (isInteractive) {
      return;
    }

    onSelect(group.id);
    onClose();
  };

  React.useEffect(() => {
    if (isOpen) {
      setSearch('');
    }
  }, [isOpen]);

  return (
    <div className={`modal-overlay ${isOpen ? 'show' : ''}`} onClick={handleOverlayClick}>
      <div className="modal-container">
        <button className="modal-close" onClick={onClose}>
          ×
        </button>

        <div className="modal-header">
          <h2 className="modal-title">
            <span>⚔️</span>
            Реестр отрядов
          </h2>
          <p className="modal-subtitle">Пригласите весь отряд в приключение</p>
        </div>

        <div className="modal-search">
          <span className="modal-search-icon">🔍</span>
          <input
            type="text"
            className="modal-search-input"
            placeholder="Поиск отряда..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className="modal-content">
          {filteredGroups.length === 0 ? (
            <div className="modal-empty-state">
              <div className="modal-empty-icon">⚔️</div>
              <div className="modal-empty-text">
                {search ? 'Отряды не найдены' : 'Нет доступных отрядов'}
              </div>
            </div>
          ) : (
            filteredGroups.map((group) => (
              <div
                key={group.id}
                className="group-card-selectable"
                onClick={(e) => handleSelect(group, e)}
              >
                <GroupCard group={group} />
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
